import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=9e3307e0"
import script from "./customer.js?vue&type=script&lang=js&external"
export * from "./customer.js?vue&type=script&lang=js&external"
import style0 from "./customer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports